import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import styled from 'styled-components';
import GlobalStyles from './styles/globalStyles';
import { AppProvider } from './context/AppContext';
import { ThemeProvider } from './context/ThemeContext';
import { NotificationProvider } from './context/NotificationContext';
import { AuthProvider } from './context/AuthContext';
import { UserFilterProvider } from './context/UserFilterContext';
import ErrorBoundary from './components/common/ErrorBoundary';
import AppRoutes from './routes';

const AppContainer = styled.div`
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background-color: ${props => props.theme.colors.background};
  color: ${props => props.theme.colors.text};
`;

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <GlobalStyles />
        <Router>
          <AppProvider>
            <AuthProvider>
              <UserFilterProvider>
                <NotificationProvider>
                  <AppContainer>
                    <AppRoutes />
                  </AppContainer>
                </NotificationProvider>
              </UserFilterProvider>
            </AuthProvider>
          </AppProvider>
        </Router>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;

